<template>
  <div class="sub_father">
    <div class="item_div">
      <img src="../../../static/img/服务5.png"/>
      <div class="item_tv">
        <p class="title">后勤整体运营服务</p>
        <p class="content">为企事业和社会组织提供专业的公共性服务，承接企事业单位后勤外包服务项目，以客户需求、市场发展为重点，通过精细化、专业化、前瞻性的运营管理模式实现了经济和社会的双效益。</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  created() {},
  computed: {},
  mounted() {},
  destroyed() {},
  methods: {},
};
</script>
<style lang="stylus" scoped>
.sub_father{
  width:100%;
  margin-top:5rem;
}
.sub_father div:first-child{
  border-top :1px dashed var(--textBlack);
  border-bottom :1px dashed var(--textBlack);
}
.item_div{
  display :flex;
  padding: 4.8rem 2rem;
  // border-top :1px dashed var(--textBlack);
  border-bottom :1px dashed var(--textBlack);

  img{
    width:42.4rem;
    height:22.5rem;
    object-fit :contain;
  }
  .item_tv{
    align-content: center;
    justify-content: center;
    justify-items: center;
    flex-direction: column;
    display: flex;
    padding-left: 7.8rem;
  
  }

  .title{
    color:var(--textBlue);
    font-size:2.1rem;
    text-align :left;
  }
  .content{
    text-align :left;
    font-size:1.8rem;
    color:var(--textBlack);
    
  }
}
@media (max-width: 800px) {
  .item_div {
  flex-wrap:wrap;

    img{
      width:100%;
    }
    .item_tv{
      padding:0;
      margin-top:5rem;
    }
  }
}
</style>